import {memo} from 'react';

import styled from 'styled-components';

import {FlexColumn} from '~/shared/theme/FlexLayout';
import ImageWithAlt from '~/shared/components/ImageWithAlt';
import {getLocalizationService} from '~/shared/services/localisationService';
import {bodyRegular, headingS, smallRegular} from '~/shared/theme/typography';
import PieButton from '~/shared/theme/pie/PieButton';
import {Link} from '~/shared/router';

import linkCreditCardSuccessImg from './assets/linkCreditCardSuccess.png';

const Root = styled(FlexColumn)`
  padding: 88px 32px 32px;
  gap: 32px;
`;

const MainContent = styled(FlexColumn)`
  gap: 24px;
  align-items: center;
`;

const StyledImageWithAlt = styled(ImageWithAlt)`
  width: 200px;
  height: 200px;
`;

const TitleContainer = styled(FlexColumn)`
  gap: 8px;
  color: ${({theme}) => theme.colors.contentDefault};
  text-align: center;
`;

const Title = styled.h3`
  ${headingS}
`;

const SubTitle = styled.span`
  ${bodyRegular}
  display: block;
`;

const CTAButton = styled(PieButton).attrs({
  variant: 'primaryLarge',
})`
  width: auto;
  padding: 10px 58px;
`;

const OTLSection = styled(FlexColumn)`
  ${smallRegular}
  text-align: center;
`;

const StyledLink = styled(Link)`
  color: ${({theme}) => theme.colors.contentLink};
  text-decoration: underline;

  :hover {
    text-decoration: underline;
  }
`;

type SuccessViewProps = {
  onCTAClick: () => void;
  onLinkClick?: () => void;
};

const SuccessView = ({onCTAClick, onLinkClick}: SuccessViewProps) => {
  const {t} = getLocalizationService();

  return (
    <Root>
      <MainContent>
        <StyledImageWithAlt
          src={linkCreditCardSuccessImg}
          alt={t('success')}
        />
        <TitleContainer>
          <Title id="modal-title">{t('great_your_credit_card_is_connected')}</Title>
          <SubTitle>{t('now_you_can_order_on_10bis_without_limits')}</SubTitle>
        </TitleContainer>
        <CTAButton onClick={onCTAClick}>{t('lets_eat')}</CTAButton>
      </MainContent>
      <OTLSection>
        <p>{t('want_to_limit_the_charge_amount')}</p>
        <p>{t('you_can_always_do_that_on_the_page')} <StyledLink onClick={onLinkClick}>{t('my_tenbis')}</StyledLink></p>
      </OTLSection>
    </Root>
  );
};

export default memo(SuccessView);
